import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { useOrpcTanstackQueryUtils } from '../orpc'

export function useDevicePasswordGetByAircraft(aircraftId: string) {
  const orpc = useOrpcTanstackQueryUtils()
  return useQuery(
    orpc.devicePassword.getByAircraft.queryOptions({ input: { aircraftId } })
  )
}

export function useDevicePasswordCreate() {
  const orpc = useOrpcTanstackQueryUtils()
  const queryClient = useQueryClient()

  return useMutation(
    orpc.devicePassword.create.mutationOptions({
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: orpc.devicePassword.key() })
      },
    })
  )
}

export function useDevicePasswordUpdate() {
  const orpc = useOrpcTanstackQueryUtils()
  const queryClient = useQueryClient()

  return useMutation(
    orpc.devicePassword.update.mutationOptions({
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: orpc.devicePassword.key() })
      },
    })
  )
}

export function useDevicePasswordDelete() {
  const orpc = useOrpcTanstackQueryUtils()
  const queryClient = useQueryClient()

  return useMutation(
    orpc.devicePassword.delete.mutationOptions({
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: orpc.devicePassword.key() })
      },
    })
  )
}
